import { createStore, applyMiddleware } from "redux";
import reducers from "./../reducers";
import thunk from "redux-thunk";
import callAPIMiddleware from "./../middleware/callAPIMiddleware";
import createSagaMiddleware, { END } from "redux-saga";
import s from "./../sagas/saga";

/**
 * Configure dev store
 */
// create the saga middleware
export default function configureStore(initialState) {
	const sagaMiddleware = createSagaMiddleware();
	let middleware = [thunk, callAPIMiddleware, sagaMiddleware];
	const createStoreWithMiddleware = applyMiddleware(...middleware)(createStore);

	const store = createStoreWithMiddleware(reducers, initialState);
	store.runSaga = sagaMiddleware.run;
	store.close = () => store.dispatch(END);
	return store;
}



// WEBPACK FOOTER //
// src/redux/store/configureStore.prod.js